import { render, staticRenderFns } from "./ReservationPromo.vue?vue&type=template&id=5659f5ce&scoped=true"
import script from "./ReservationPromo.vue?vue&type=script&lang=js"
export * from "./ReservationPromo.vue?vue&type=script&lang=js"
import style0 from "./ReservationPromo.vue?vue&type=style&index=0&id=5659f5ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5659f5ce",
  null
  
)

export default component.exports